import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { useContext, useEffect, useReducer, useState } from 'react';
import { Image } from 'semantic-ui-react';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { storageGalleryProps, uploadHandlers, uploadInitialState, uploadReducer } from '../../cnr/reducers/UploadReducer';
import UiSaveButtons from '../../components/buttons/UiSaveButtons';
import { appIconTypes } from '../../enums/appIconTypes';
import { gEnums } from '../../enums/globalEnums';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';
import ImageDropzone from '../uploading/ImageDropzone';
import UploaderWithProvider from '../uploading/Uploader';

/**
 * 
 * @param {object} props (profileStorageFile: {urls: {full, thumbnail}})
 * @returns An Image or NoData (if full is empty)
 */
const ProfileImage = (props) => {

  const { profileStorageFile, inWizard, updateWizard } = props

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { app_state, paps_state } = states
  const { mainStorage } = app_state
  const { storagePaths, view, viewKey } = paps_state

  // appUserAccess
  const appUserAccess = useAppUserAccess()
  const { appUserAccessType, email: email_profile } = appUserAccess ?? {}

  const _email = email_profile // email ? email : email_profile

  let storageLocationType;

  switch (appUserAccessType) {
    case gEnums.appUserAccessTypes.admin:
    case gEnums.appUserAccessTypes.superAdmin:
      storageLocationType = gEnums.storageLocationTypes.profiles
      break;
    default:
      storageLocationType = gEnums.storageLocationTypes.clientProfile
  }

  const _sp = {
    appUserAccess,
    storageLocationType,
    storageType: gEnums.storageTypes.image,
    storagePaths,
    viewItem_key: view,
    viewItem_id: viewKey,
  }

  const sgps = storageGalleryProps(_sp)
  const { storageRef } = sgps ? sgps : {}

  // uploadState
  const init_state_u = { states, mainStorage, storageType: gEnums.storageTypes.image, storageRef, storageLocationType, appUserAccess }
  const [upload_state, uploadDispatch] = useReducer(uploadReducer, uploadInitialState(init_state_u));
  const upload_handlers = uploadHandlers(uploadDispatch, upload_state)
  const { firstSelectedFile, updating, confirmation } = upload_state ?? {}

  const [profileItem, setProfileItem] = useState()
  const { urls } = profileItem ? profileItem : {}
  const { full } = urls ?? {}

  const [showUpload, setShowUpload] = useState()

  // const _callback = (galleryResponse) => {
  //   const { galleryItems } = galleryResponse ? galleryResponse : {}
  //   const _profileItem = galleryItems && galleryItems[_email] ? galleryItems[_email] : null
  //   setProfileItem(_profileItem)
  // }

  useEffect(
    () => {
      // if (!profileStorageFile) {
      //   getGallery_clientProfiles(mainStorage, pathViews, appUserCollection, _email, _callback)
      // } else {
      //   setProfileItem(profileStorageFile)
      // }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  useEffect(
    () => {
      updateWizard && updateWizard({ upload_state, upload_handlers })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const handleShowUpload = () => setShowUpload(!showUpload)

  const upload_dropzone = () => <ImageDropzone
    storageType={gEnums.storageTypes.image}
    imageFile={firstSelectedFile}
  />

  const image = () => <Image className={'img-profile'} src={full} />

  const content = () => full ? image() : upload_dropzone()

  const footer = () => <UiSaveButtons
    save={{ oc: handleShowUpload, caption: 'Update Image', icon: appIconTypes.arrowRight, color: 'blue' }}
  />

  const wrapper = () => <Wrapper
    content={content()}
    footer={!inWizard && footer()}
    wrapperType={wrapperTypes.paddedFooter}
    css={{ content: 'margin-auto' }}
    confirmation={confirmation}
    updating={updating}
  />

  if (showUpload) {
    return <UploaderWithProvider
      handleCancel={handleShowUpload}
      itemData={{}}
      origin={'FullImage'}
      storageLocationType={gEnums.storageLocationTypes.pages}
      useFull={true}
    />
  } else {
    return wrapper()
  }
}

export default ProfileImage